import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-send",
  "use": "icon-send-usage",
  "viewBox": "0 0 128 128",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\" id=\"icon-send\"><defs></defs><path class=\"cls-1\" d=\"M.061,118.85714,128,64,.061,9.14286,0,51.80952,91.42857,64,0,76.19048Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol